module.exports = __webpack_public_path__ + "static/paper-size-71773c2ad8d524e8b1d789345e4a3a97.png";